import { useState, useCallback } from 'react';
import setNotificationCookie from '../notification-banner/setNotificationCookie';

const useShowNotification = notification => {
  const [showNotification, setShowNotification] = useState(
    !!(notification && notification.content)
  );

  const setCookieAndHideNotification = useCallback(() => {
    if (notification?.dismiss) {
      setNotificationCookie(notification.dismiss);
    }
    setShowNotification(false);
  }, []);

  return [showNotification, setCookieAndHideNotification];
};

export default useShowNotification;
